// Builds the author* publicData fields written onto a freelancer's listings so
// listing cards (BrowseFreelancersResults, ListingUserCard) and search filters
// (BrowseFreelancersPage) stay in sync with the user's profile. Used by both
// EditListingPage.duck.js (on listing create/update) and
// ProfileSettingsPage.duck.js (on profile save).
//
// Pass the freshly-updated currentUser — never a partial action payload —
// otherwise fields not in the partial payload get clobbered to empty.

import { languageKeys } from './data';

const HOURLY_FEE_TO_RATE = {
  '20-39 / h': '20-39',
  '40-59 / h': '40-59',
  '60-79 / h': '60-79',
  '80-99 / h': '80-99',
  '+ 100 / h': '100+',
};

const workHistoryToString = entries =>
  (entries || [])
    .map(e => [e?.task, e?.customerName].filter(Boolean).join(' '))
    .filter(Boolean)
    .join(', ');

export const buildAuthorPublicData = (currentUser, { includeLocation = false } = {}) => {
  const publicData = currentUser?.attributes?.profile?.publicData || {};
  const hourlyRate = HOURLY_FEE_TO_RATE[publicData.hourlyFee] || '';
  const skillsKeys = publicData.experienceKeys || [];
  const toolsKeys = publicData.toolsKeys || [];
  const languagesKeys = languageKeys(publicData.languages);

  const fields = {
    authorBio: publicData.bio || '',
    authorWhoAmI: publicData.whoAmI || '',
    authorHourlyRates: hourlyRate ? [hourlyRate] : [],
    authorDontShowHourlyFee: publicData.dontShowHourlyFee || false,
    authorSkillsKeys: skillsKeys,
    authorSkillsString: skillsKeys.join(','),
    authorToolsKeys: toolsKeys,
    authorToolsString: toolsKeys.join(','),
    authorLanguagesKeys: languagesKeys,
    authorLanguagesString: languagesKeys.join(','),
    authorHobbiesKeys: (publicData.hobbies || []).map(h => h.category).filter(Boolean),
    authorIdealCustomer: publicData.idealCustomer || '',
    authorWorkExperienceString: workHistoryToString(publicData.workExperience),
    authorWorkedWithString: workHistoryToString(publicData.workedWith),
  };

  if (includeLocation) {
    fields.locationCity = publicData.locationCity || '';
    fields.locationCountry = publicData.locationCountry || '';
    fields.locationCountryCode = publicData.locationCountryCode || '';
  }

  return fields;
};
